window.updateInterval = function() {
  return Math.floor(Math.random() * (15000 - 1500) + 1500);
}

